import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useAppSelector } from '../../../../../../app/app-hooks';
import { selectAllFundingExplorerGrants } from '../../../../../../features/api/slices/grants-slice';
import { PreviewContent } from '../../../../data/steps-content';
import OnboardingCarrousel from './components/carrousel';
import { getCarouselImages } from './components/carrousel/content/images';
import OnboardingGrantsSuggestions from './components/grants-suggestions';
import OnboardingImage from './components/image';
import { PreviewContainer } from './styles';

interface OnboardingLayoutPreviewContainerProps {
  previewType: PreviewContent;
}
const OnboardingLayoutPreviewContainer: React.FC<
  OnboardingLayoutPreviewContainerProps
> = ({ previewType }) => {
  const suggestedGrants = useAppSelector(selectAllFundingExplorerGrants);
  const { selectedLocale } = useLocale();

  if (previewType === 'none') return null;

  if (
    previewType === 'grants' &&
    (!suggestedGrants || suggestedGrants.length === 0)
  )
    return null;

  const images = getCarouselImages(selectedLocale);

  return (
    <PreviewContainer $previewContent={previewType}>
      {previewType === 'picture' ? (
        <OnboardingImage
          src="https://images.ctfassets.net/uqnk3k6tiu47/5XZN1qX6WcldVVCUxTnkHM/a1994869db1563bfcb5e8514f4041bda/IMG_1688.JPG"
          alt="Welcome Image"
        />
      ) : previewType === 'grants' ? (
        <OnboardingGrantsSuggestions />
      ) : previewType === 'carousel' ? (
        <OnboardingCarrousel images={images} />
      ) : null}
    </PreviewContainer>
  );
};

export default OnboardingLayoutPreviewContainer;
